import styled from '@emotion/styled';

const WorldSelectWrapper = styled('section')({
  maxWidth: '100%',
});

export default WorldSelectWrapper;
